<template>
  <div>
    <div class="mask1" v-if="maskshow"></div>
    <div class="mask2" v-if="maskshow1"></div>
    <div class="mask3" v-if="maskshow2"></div>
    <div v-show="!showTips">
      <div class="cover">
        <!-- <div class="back-btn" @click="handleBack">
          <img src="../../../statics/imgs/ico_fanhui@2x.png" />
        </div>  -->
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="(item,index) of goodsInfo.img_list" :key="index">
            <img :src="item"  style="width: 100%;"/>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="info">
        <div class="price">
          <span class="symbol">￥</span>
          <span class="num">{{goodsInfo.price}}</span>
        </div>
        <div class="inventory-num" v-if="goodsInfo.infinite !== 1">库存: {{ goodsInfo.count }}</div>
      </div>
      <div class="goods-title">{{goodsInfo.name}}</div>
      <div class="goods-detail">
        <div class="title">详情</div>
        <div class="text-desc" v-dompurify-html="goodsInfo.desc"></div>
      </div>
      <div class="buy-btn">
        <van-button type="primary" :class="{ 'disabled': goodsInfo.infinite == 0 && goodsInfo.count == 0}" round 
          size="large" @click="toConfirm">立即购买</van-button>
      </div>
      <div class="consultTeacher" v-if="confirm">
        <div class="consultTeacherMain" >
            <div class="header">
                <span>确认订单</span>
            </div>
            <div class="TeacherList">
                <div class="teacherCell order" >
                    <img :src="goodsInfo.cover" class="cover">
                    <div class="goods-content">
                      <div class="goods-title">{{goodsInfo.name}}</div>
                      <div class="goods-price">
                        <span class="money-symbol">￥</span>
                        <span class="money-num">{{goodsInfo.price}}</span>
                        <div class="stepper">
                          <van-stepper v-model="goodsNum" theme="round" integer  />
                        </div>      
                      </div>
                    </div>     
                </div>
                <div class="form-wrap">
                  <van-cell-group>
                    <van-field
                    v-model="form[`custom${item.id}`]['value']"
                    :label="item.name"
                    :placeholder="`请输入${item.name}`"
                    :required="(item.required == 1)"
                    v-for="(item,index) in formList"
                    :key="index" />
                  </van-cell-group>
                  <!-- <div class="form" style="margin-bottom:20px" v-for="(item,index) in formList" :key="index">
                    <i style="color:red" v-if="(item.required == 1)">*</i>
                    <span style="margin-right:10px">{{item.name}}：</span>
                    <input :placeholder="`请填写${item.name}`" v-model="form[`custom${item.id}`]['value']" />
                  </div> -->
              </div>
            </div>
            <div class="footer">
              <span class="sum-text">合计：</span>
              <div class="sum-money">
                <span>￥</span>
                <span>{{(goodsInfo.price * goodsNum).toFixed(2)}}</span>
              </div>
              <div class="comfirm-btn">
                <button @click="submitOrdert">提交订单</button>
              </div>
            </div>
            <img class="closeBtn" @click="closeBtnClicked" src="https://tengfaceliveuser.tengface.net/web/wx-user/img/yuan_close.png">
        </div>
      </div>
      <!-- <div @scroll="pageScroll" class="mask"></div> -->
            <!-- QQ登录 -->

      <van-popup
          v-model="showWxPopUp"
          :close-on-click-overlay="false"
          class="qqLogin"
          :style="{ width: '70%' }"
          :overlay-style="{ zIndex: '2001' }"
        >
          <div class="loginWay">
            <div class="qqtitle">微信授权登录即可查看详情</div>
            <div class="qqBox">
              <van-button @click="wxloginTap" style="padding:0px 45px;" round type="primary">确认登录</van-button>
              <div @click="closeWindow" style="padding-top:30px;color:#c9c9c9;">取消</div>
            </div>
          </div>
      </van-popup>

             <!-- ali授权 -->
      <van-popup
          v-model="showAliPopUp"
          :close-on-click-overlay="false"
          class="qqLogin"
          :style="{ width: '70%' }"
          :overlay-style="{ zIndex: '2001' }"
        >
          <div class="loginWay">
            <div class="qqtitle">支付宝授权登录即可查看详情</div>
            <div class="qqBox">
              <van-button @click="aliLoginTap" style="padding:0px 45px;" round type="primary">确认登录</van-button>
              <div @click="closeAliWindow" style="padding-top:30px;color:#c9c9c9;">取消</div>
            </div>
          </div>
      </van-popup>     
    </div>
    <div v-show="showTips" class="tips">
      <img src="../../../statics/imgs/no.png" />
      <span>{{tipsText}}</span>
      </div>
      <div class="dialogpay" v-if="paydatile">
          <img  @click="close1" class="payclose" src="../../../statics/imgs/cc.png" />
          <div class="paytitle">
            支付详情
          </div>
          <div>
            <div class="payname">
              {{goodsInfo.name}}
            </div>
            <div class="qpayb">
              <span >￥</span>
              <span class="payprice">{{goodsInfo.price}}</span>
            </div>
            <div>
                <div class="paybx" v-if="platform == 'wx'||!platform">
                  <div class="wxpaybx">
                    <img src="../../../statics/imgs/wx.png" class="logot" mode=""/>
                    <span>微信支付</span>
                  </div>
                  <div  @click="qcheck">
                    <img v-if="!wxcheck" class="checkin" src="../../../statics/imgs/wk.png" mode=""/>
                      <img v-else class="checkin" src="../../../statics/imgs/xz.png" mode=""/>
                  </div>
                </div>
                <div class="paybx" v-if="platform == 'ali'||!platform">
                  <div class="wxpaybx">
                    <img src="../../../statics/imgs/zfb.png" class="logot" mode=""/>
                    <span>支付宝支付</span>
                  </div>
                  <div @click="qcheck1">
                    <img v-if="!apilcheck" class="checkin" src="../../../statics/imgs/wk.png" mode=""/>
                      <img v-else class="checkin" src="../../../statics/imgs/xz.png" mode=""/>
                  </div>
              </div>
            </div>
            <div class="qrpaybx">
               <div class="qrpay"  @click="quzhifu">
                确认支付
              </div>
            </div>
           
          </div>
      </div>
      <div class="dialogpay" v-if="coyshow">
        <div class="paytitle">
          支付宝支付
        </div>
        <div>
          <img  class="payclose" @click="close2" src="../../../statics/imgs/cc.png" />
            <div class="tzbx1">
            <div  class="tzbx">
              <img  class="tzbxs" src="../../../statics/imgs/copy.png" />
              <div class="coybx">
              <div> 复制链接</div>
              <div class='coy'> 点击右侧按钮复制链接</div>
              </div>
            </div>
              <div class="copy1" @click="copy">
                复制
              </div>
            </div>
        </div>
        <div class="bzt">
          <img src="../../../statics/imgs/xj.png" class="logot logot1" mode=""/>
        </div>
          <div class="tzbx">
          <div >
            <img class="tzbxs" src="../../../statics/imgs/llq.png" mode=""/>
          </div>
            <div class="coybx">
              <div >在浏览器粘贴链接</div>
              <div class='coy'>打开手机浏览器，粘贴链接并使用</div>
            </div>
          </div>
        </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Swipe, SwipeItem, Notify, Field, Toast } from 'vant';
import tool from "../../kits/Tools.js";
import axios from 'axios'
import { useOrgConfig } from '../../kits/useOrgConfig.js'

Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Notify);
Vue.use(Field);
Vue.use(Toast);
  export default {
    data(){
      return{
        paydatile:false,
        maskshow:false,
        maskshow1:false,
        maskshow2:false,
        coyshow:false,
        wxcheck:1,
        apilcheck:0,
        gid:'',
        goodsInfo:{},
        confirm:false,
        goodsNum:1,
        username:'',
        tel:'',
        formList:[],
        form:{},
        ds_id:'',
        app_id:'wxf7f90bb2c6ec7815',
        showWxPopUp:false,
        showAliPopUp:false,
        showTips:false,
        uid:'',
        wx_app_id:'',
        ali_app_id:'',
        platform:'',
        channel_id: '',
        tipsText:'',
        aliCode:'',
        fans:'',
        header:'',
        nick:'',
        aLiPayUrl: '',
        loginAliUrl:''
      }
    },
    watch: {
      goodsNum(val) {
        if(val < 1) {
          Notify('商品数量必须大于1')
          this.goodsNum = 1
          return
        }
        if(this.goodsInfo.infinite == 0 && this.goodsInfo.count < val) {
          Notify('商品数量不能大于库存数')
          this.goodsNum = this.goodsInfo.count
          return
        }
      }
    },
    async created(){
      this.ds_id = tool.getDs_id();
      this.gid = this.$route.query.id
      this.uid = this.$route.query.uid
      this.platform = this.$route.query.platform
      this.channel_id = this.$route.query.channel_id
      if(!this.ds_id) {
        this.ds_id = this.$route.query.dsId || this.$route.query.ds_Id || this.$route.query.ds_id
      } 
      if(this.channel_id === 'null') {
        this.channel_id = ''
      }
      if (this.platform == 'ali') {
         this.qcheck1()
      }else if (this.platform == 'wx') {
        this.qcheck()
      }
      console.log(this.platform,'this.platform')
      if(this.platform){
        this.ds_id = this.$route.query.dsId || this.$route.query.ds_id
      }
      this.aliCode = this.$route.query.aliCode
      // await this.getAppId(this.uid)
      // if(tool.isWeixin()){
      //     if(this.platform == 'ali'){
      //       this.tipsText = '请在支付宝内打开'
      //       this.showTips = true
      //       return
      //     }
      //     this.login(this.wx_app_id)
      // }else if(this.isInAliPay()){
      //   if(this.platform == 'wx'){
      //       this.tipsText = '请微信内打开'
      //       this.showTips = true
      //       return
      //     }
      //     this.aliLogin(this.ali_app_id)
      // }else{
      //     this.tipsText = '请在微信或者支付宝内打开'
      //     this.showTips = true
      // }
      this.getGoodsDetail(this.gid)
    },
    mounted(){
      
    },
    methods:{
      async getOrgPayConfig(opid){        
        try {
          const option = `opid=${opid}`
          const res = await axios.post('https://zhifu-api.tenghuiwangxiao.cn/common/getOrgPayConfig', option)
          this.wx_app_id  = res.data.data.wxappid
          if (this.wx_app_id) {
            tool.setAppID(this.wx_app_id)
          }
          this.ali_app_id = res.data.data.aliappid
          this.loginAliUrl = res.data.data.aliurl
          console.log("getOrgPayConfig",res)

          if(tool.isWeixin()){
                if(this.platform == 'ali'){
                  this.tipsText = '请在支付宝内打开'
                  this.showTips = true
                  return
                }
                this.login(this.wx_app_id)
            }else if(this.isInAliPay()){
              if(this.platform == 'wx'){
                  this.tipsText = '请微信内打开'
                  this.showTips = true
                  return
                }
                this.aliLogin(this.ali_app_id)
            }else{
                this.tipsText = '请在微信或者支付宝内打开'
                this.showTips = true
            }
        } catch (error) {
          
        }
      },
      close1(){
        this.paydatile=false
        this.closeBtnClicked()
        this.maskshow=false
      },
      close2(){
        // console.log(888);
        this.coyshow=false
        // this.maskshow=false
        this.closeBtnClicked()
        this.maskshow=false
      },
      copy(){
        let copy = this.aLiPayUrl
        this.$copyText(copy).then(
          () => {
            Notify({ type: 'success', message: '复制成功',background: '#4fc08d', })
            // Toast('复制成功！');
            });
      },
      quzhifu(){
        if (!this.platform) {
          if (!this.apilcheck){
            // 微信支付
            this.submitOrder()
            // console.log('微信支付')
          }else{
            this.submitOrder()
            // 支付宝
            this.coyshow=true
            this.paydatile=false
            this.confirm=false
            this.maskshow2=false
          }
        }else{
          this.submitOrder()
        }
      },
      submitOrdert(){
        var that = this
        for(var i in this.form) {
          if(i){
            if(this.form[i].required == 1 && !this.form[i].value){
              Notify(`请填写${this.form[i].name}`)
              return
            }
          }
        }
        const extObj = {}
        for(var i in this.form) {
          extObj[this.form[i].id] = this.form[i].value
        }
        //URL支付
        if (this.goodsInfo.flag == 2) {
          this.submitLinkURlOrder(this.goodsInfo.payurl)
          return
        }
        this.maskshow=true 
        this.paydatile=true
      },
      qcheck(){
    // console.log(e);
        this.wxcheck=1,
          this.apilcheck=0
      },
      qcheck1(){
    // console.log(e);
        this.wxcheck=0,
          this.apilcheck=1
      },
      handleBack(){
        this.$router.back()
      },
      toConfirm(){
        if (this.goodsInfo.flag == 2) { //链接购买
            location.href = this.goodsInfo.payurl
        }else{
          const { count, infinite } = this.goodsInfo
          if(count == 0 && infinite == 0) {
            Notify('商品库存不足')
            return
          }
          this.confirm = true
          this.maskshow2 = true
          this.stopScroll()
        }
      },
      closeBtnClicked(){
        this.confirm = false
        this.maskshow2 = false
        this.canScroll()
      },
      // 获取appid
      async getAppId(uid){
        const {data:{data:{appid, ali_appid}}} =  await this.axios.get(tool.baseUrl2() + "/user/login/getWxAppid?uid=" + uid)
        if(appid){
          this.wx_app_id = appid
          tool.setAppID(this.wx_app_id)
        }
        if(ali_appid){
          this.ali_app_id = ali_appid
        }
      },
      login(appId){
          if(!this.getCache(appId) || !this.fans.openid){
            const loginCode = tool.getQueryString("code")
            if(!loginCode){
                this.showWxPopUp = true
            }else{
              console.log('code',loginCode)
              const loginUrl = tool.baseUrl2() + "/user/login/wxAuthForGoods?code=" + loginCode + "&goods_id=" + this.gid;
              console.log('loginUrl',loginUrl)
              axios
                  .get(loginUrl,{timeout: 2000})
                  .then(res=> {
                    console.log(res)
                    if (res.data.code == 200) {
                      const data = res.data.data;
                      const fans = {
                        fans_id: data.fans_id,
                        header: data.header,
                        nick: data.nick,
                        userSig: data.tsl_sig,
                        real_auth: data.real_auth,
                        status: data.status,
                        token: data.token,
                        openid:data.openid
                      };
                      this.header= data.header
                      this.nick= data.nick
                      if (appId) {
                        localStorage.setItem("current_app_Id",appId);
                        localStorage.setItem(appId, JSON.stringify(fans));
                      }
                    } else if (data.data.code == 400) {
                        this.initLoginJumpWx(appId);                      
                    }
                  })
            }
          }
      },
      async aliLogin(appId){
        if(!this.getCache(appId)){
            if(!this.aliCode){
                this.showAliPopUp = true
            }else{
                if (appId && this.aliCode) {
                  const res =  await axios.get(tool.baseUrl2() + `/user/login/zfbLogin?code=${this.aliCode}`)
                  const {code,data:{avatar,nick_name,user_id}} = res.data
                  if(code == 200){
                  const fans ={
                      header:avatar,
                      userId:user_id,
                      nick:nick_name
                    }
                    this.header= avatar
                    this.nick= nick_name
                    localStorage.setItem("current_app_Id",appId);
                    localStorage.setItem(appId, JSON.stringify(fans));
                    // this.clearAliInfo()
                  }
                }
            }         
            }
      },
      // 清除支付宝授权信息
      clearAliInfo(){
        const data = getQueryData(window.location.href);
        data.aliCode = ''
        if(tool.checkPhoneType() == 2){
          var url = tool.getUrlAddQuery(window.location.pathname,data);
          console.log(url)
          window.history.replaceState({}, "除去URL参数", url);
        }else{
          var url = tool.getUrlAddQuery(window.location.protocol + "//" + window.location.host + window.location.pathname,data);
          window.location.href = url;
        }
      },
      //微信确认登录
      async initLoginJumpWx(appid){
        let redirect_uri = window.location.href;
        redirect_uri = redirect_uri.split("&code")[0];
        console.log('redirect_uri',redirect_uri)
        // window.location.href =
        //   "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        //   appid +
        //   "&redirect_uri=" +
        //   encodeURIComponent(redirect_uri) +
        //   "&response_type=code&scope=snsapi_userinfo&state=STATE";
        const redirectUrl = encodeURIComponent(redirect_uri)

        let loginAuthUrl = this.$store.state.setting.defaultConfig.wechat_auth_domain
        let wecahtAppId = this.$store.state.setting.defaultConfig.official_account_appid
        if(!loginAuthUrl) {
          const myConfig = await useOrgConfig(this.uid)
          loginAuthUrl = myConfig.wechat_auth_domain
          wecahtAppId = myConfig.official_account_appid
          this.$store.commit('setting/setDefaultConfig', myConfig)
        }
        // window.location.href = `https://login1.bbxiuc.cn/login/#/wx-login?appId=${appid}&redirectUrl=${redirectUrl}&title=${this.goodsInfo.name}&origin=tengface`
        window.location.href = `${loginAuthUrl}/login/#/wx-login?appId=${wecahtAppId}&uId=${this.uid}&redirectUrl=${redirectUrl}&title=登录&origin=tengface`
      },
      // 取消登录
      closeWindow(){
        wx.closeWindow()
      },
      closeAliWindow(){
        AlipayJSBridge.call('closeWebview')
      },
      // 点击登录
      wxloginTap(){
        this.initLoginJumpWx(this.wx_app_id)
      },
      aliLoginTap(){
        // const url = `https://login.tengface.net/login?appid=${this.ali_app_id}&redirect_url=${encodeURIComponent(window.location.href)}`
        const url = `${this.loginAliUrl}ali_login?appid=${this.ali_app_id}&redirect_url=${encodeURIComponent(window.location.href)}`
        window.location.href = url
      },
      getCache(appIdTmp) {
        //判断缓存是否存在
        try {
          let fans = JSON.parse(localStorage.getItem(appIdTmp));
          this.fans = fans
          if (fans) {
            return true;
          }
        } catch (e) {
          localStorage.removeItem(appIdTmp);
          return false;
        }
        return false;
      },
      // 判断是否在支付宝浏览器
      isInAliPay(){
       if (/AlipayClient/.test(window.navigator.userAgent)) {
          //判断是否是支付宝浏览器打开
          return true
        }
      },
      // 获取商品详情
      async getGoodsDetail(id){
        // const option = "id="+ id
        try{
          const appid = localStorage.getItem("current_app_Id")
          const fans =  JSON.parse(localStorage.getItem(appid) || "{}")
          // tool.baseUrl2()+
          var option = `id=${id}&type=1&ds_id=${this.ds_id}&fans_id=${fans.fans_id}&channel_code=${this.channel_id}`
            // "id=" +
            // id +
            // "&type=1" +
            // "&ds_id=" +
            // this.ds_id +
            // "&fans_id=" +
            // fans.fans_id +
            // "&channel_id=" +
            // this.channel_id;
          const {data:{data}} =  await this.axios.post(tool.baseUrl2()+'/goods/info',option)
          // const {data:{data}} = await this.axios.post(`http://liveapi2.tenghuiwangxiao.com/api/goods/info`, option)
          console.log(data)
          data.desc = data.desc.replace(
            /<iframe /g,
            '<iframe style= "width:100%"'
          )
          console.log(data.desc)
          this.goodsInfo = data
          if (data.flag != 2) { //链接支付 
            this.getOrgPayConfig(data.opid)
          }
          this.formList = JSON.parse(data.ext)
          this.formList.forEach(item => {
            this.$set(this.form, 'custom' + item.id, {value:'',required:item.required, name:item.name, id:item.id})
          })
          this.getGoodsNum()
        }catch(error){
          console.log(error)
        }      
      },
      // 提交订单
      async submitOrder(){
        this.maskshow1=true
        // console.log('微信支付')
        for(var i in this.form) {
          if(i){
            if(this.form[i].required == 1 && !this.form[i].value){
              Notify(`请填写${this.form[i].name}`)
              return
            }
          }
        }
        const extObj = {}
        for(var i in this.form) {
          extObj[this.form[i].id] = this.form[i].value
        }

        let data ={
          goods_id:this.gid,
          num:this.goodsNum,
          channel_id: this.channel_id
        }

        if(this.ds_id){
          data.ds_id = this.ds_id
        }
        //  console.log('zhifu')
        if(this.isInAliPay()){
          const appid = localStorage.getItem("current_app_Id");
          const fans =  JSON.parse(localStorage.getItem(appid) || "{}")
          data.nick_name = fans.nick
          data.header = fans.header

        }else{
          const appid = localStorage.getItem("current_app_Id");
          const fans =  JSON.parse(localStorage.getItem(appid) || "{}")
          data.fans_id = fans.fans_id
          data.nick_name = fans.nick
          data.header = fans.header
        }
         this.header=data.header
         this.nick_name=data.nick_name
        data = {...data,...extObj}
        let option = ''
        for(var i in data) {
          if(data[i]){
            option = option + `${i}=${data[i]}&`
          }
        }
        option = option.slice(0,option.length-1);
        const { data: { code, data:resData, message } } = await axios.post(tool.baseUrl2() + '/goods/submitOrder', option)
        
        // const { data: { code, data:resData, message } } = await axios.post('http://liveapi2.tenghuiwangxiao.com/api/goods/submitOrder', option)

        // const {data:{order_no,money}, code} = res.data
        // console.log('data',code)
        if(code==200){
          // this.maskshow1=false
          const { money, order_no } = resData
          this.handlePayRequest(money,order_no)
        }else{
          this.maskshow1=false
          Notify(message)
        }
      },
      async submitLinkURlOrder(payUrl){
        this.maskshow1=true
        // console.log('微信支付')
        for(var i in this.form) {
          if(i){
            if(this.form[i].required == 1 && !this.form[i].value){
              Notify(`请填写${this.form[i].name}`)
              return
            }
          }
        }
        const extObj = {}
        for(var i in this.form) {
          extObj[this.form[i].id] = this.form[i].value
        }

        let data ={
          goods_id:this.gid,
          num:this.goodsNum,
          payurl:payUrl,
          channel_id: this.channel_id
        }

        if(this.ds_id){
          data.ds_id = this.ds_id
        }
        //  console.log('zhifu')
        if(this.isInAliPay()){
          const appid = localStorage.getItem("current_app_Id");
          const fans =  JSON.parse(localStorage.getItem(appid) || "{}")
          data.nick_name = fans.nick
          data.header = fans.header

        }else{
          const appid = localStorage.getItem("current_app_Id");
          const fans =  JSON.parse(localStorage.getItem(appid)|| "{}")
          data.fans_id = fans.fans_id
          data.nick_name = fans.nick
          data.header = fans.header
        }
         this.header=data.header
         this.nick_name=data.nick_name
        data = { ...data,...extObj }
        let option = ''
        for(var i in data) {
          if(data[i]){
            option = option + `${i}=${data[i]}&`
          }
        }
        option =option.slice(0,option.length-1);
        try {
          const { data: { code, message } } = await axios.post(tool.baseUrl2() + '/goods/submitOrder', option)
          // const {data:{order_no,money}, code} = res.data
          // console.log('data',code)
          if(code==200){
            this.maskshow1=false
            location.href = payUrl
          }else{
            this.maskshow1=false
            Notify(message)
          }
       } catch (error) {
          this.maskshow1=false
       }
      },
      async handlePayRequest(money,orderno){
        const appid = localStorage.getItem("current_app_Id");
        const fans =  JSON.parse(localStorage.getItem(appid) || "{}")
         let data = {
            money,
            orderno,
            opid:this.goodsInfo.opid,
            uid:this.uid,
            header:fans.header,
            nick:fans.nick,
            channel_id: this.channel_id
         }
         this.header=data.header
         this.nick=data.nick
         console.log('data----',data)
         if(this.isInAliPay()){
            data.flag = 3
            data.alipayid = fans.userId
         }
         if(tool.isWeixin()){
            if(this.wxcheck === 1) {
              data.flag = 1 // 微信公众号
            } else {
              data.flag = 3  // 复制支付宝链接支付
            }
            data.openid =  fans.openid
            data.fansid = fans.fans_id
         }
         if (tool.isWeixinMP()) { //小程序
              let option = ''
              for(var i in data) {
                  if(data[i]){
                    option = option + `${i}=${data[i]}&`
                  }
              }
           option =option.slice(0,option.length-1);
           wx.miniProgram.navigateTo({url:`/pages/pay/pay?${option}`})
         }else {
                let option = ''
              for(var i in data) {
                  if(data[i]){
                    option = option + `${i}=${data[i]}&`
                  }
                }
                
              option =option.slice(0,option.length-1);
              const res = await axios.post('https://zhifu-api.tenghuiwangxiao.cn/cartPay', option)
              const {code, data:{rc_Result}} = res.data
              console.log(res.data)
              if(code === 2000 && rc_Result && this.wxcheck === 0 && !this.isInAliPay()) {
                this.maskshow1=false
                this.aLiPayUrl = rc_Result
                return
              }
              if(code == 2000 && rc_Result){
                this.maskshow1=false
                  window.location.href = rc_Result
              }else if(code == 2000 && tool.isWeixin()){
                this.maskshow1=false
                this.onBridgeReady(res.data.data)
              }else{
                this.maskshow1=false
                Notify(res.data.data)
              }
         }
         
      },
      onBridgeReady(params) {
        WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
            "appId": params.appId,  //公众号名称，由商户传入
            "timeStamp": String(params.timeStamp), //支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            "nonceStr": params.nonceStr,  //支付签名随机串，不长于 32 位
            "package": params.package,//统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            "signType": 'MD5',  //签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            "paySign": params.paySign, //支付签名
        },
        function (res) {
            if (res.err_msg === "get_brand_wcpay_request:ok") {
                Toast('支付成功！');
            } else if (res.err_msg === "get_brand_wcpay_request:fail") {
                Toast('支付失败！');
            }
        });
    },
   //禁止滚动
   stopScroll(){
        var mo=function(e){e.preventDefault();};
        document.body.style.overflow='hidden';
        document.addEventListener("touchmove",mo,false);//禁止页面滑动
    },
    /***取消滑动限制***/
    canScroll(){
        var mo=function(e){e.preventDefault();};
        document.body.style.overflow='';//出现滚动条
        document.removeEventListener("touchmove",mo,false);
    },
    async getGoodsNum() {
        // const res =  await axios.post(tool.baseUrl2()+'/goods/goodsInventory',option)
        const option = `ds_id=${this.ds_id}&goods_id=${this.goodsInfo.id}`
        const { data: { code, data } } =  await axios.post(tool.baseUrl2()+'/goods/goodsInventory',option)
        // const option = `ds_id=209972&goods_id=27`
        // const { data: { code, data } } =  await axios.post('http://liveapi2.tenghuiwangxiao.com/api/goods/goodsInventory',option)
        if(code === 200) {
          this.goodsInfo = { ...this.goodsInfo, count: data.count, infinite: data.infinite }
        }
      }
    }
  }
</script>

<style lang="less" scoped>
.cover{
  width: 100%;
  position: relative;
  .poster{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
  }
  .back-btn{
    position: absolute;
    z-index: 10;
    width: 30px;
    height: 30px;
    top: 13px;
    left: 13px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    img{
      width: 20px;
      height: 20px;

    }
  }
}
.dialogpay{
  position: fixed;
  width: 100%;
  /* height: 610rpx; */
  /* border-radius: 20rpx; */
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  bottom: 0;
  background-color: white;
  z-index: 9999999;
}
.info {
  display: flex;
  align-items: center;
  padding: 0 16px;
  .price{
    width: 100%;
    height: 54px;
    box-sizing: border-box;
    // padding-left: 16px;
    color: #F34718;
    font-weight: 700;
    display: flex;
    align-items: center;
    // margin-bottom: 10px;
    .symbol{
      font-size: 16px;
    }
    .num{
      font-size: 28px;
    }
  }
  .inventory-num {
    flex-shrink: 0;
  }
}

.goods-title{
  color: #101010;
  font-weight: 700;
  line-height: 28px;
  box-sizing: border-box;
  padding: 0 16px;
  overflow: hidden;
  font-size: 18px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal !important;
  word-wrap: break-word; 
  margin-bottom: 16px;
}
.payname{
  color: #888888;
  font-size: 12px;
  margin-top: 34px;
  text-align: center;
}
.goods-detail{
  box-sizing: border-box;
  padding: 0 16px;
  color: #101010;
  .title{
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 16px;
  }
  .text-desc{
    width: 100%;
    padding-bottom: 50px;
  }
}
.buy-btn{

  position: fixed;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  width: 75%;
}

.buy-btn .van-button.disabled {
  background-color: #dddddd;
  border-color: #dddddd;
}

.consultTeacher{
  width: 100%;
  height: 500px;
  position:fixed;
  bottom: 0px;
  left: 0px;
  z-index: 5100;
}
.payclose{
  position: absolute;
  right: 20px;
  top: 15px;
  width: 20px;
  height: 20px;
}
.paytitle{
  width: 100%;
  text-align: center;
  color: #000000;
  font-size: 16px;
  font-weight: 700;
  margin-top: 18px;
}
.consultTeacher .consultTeacherMain{
  position:relative;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  width: 100%;
  height: 100%;
  background-color: white;
}

.consultTeacher .messageMain{
  position:relative;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  width: 100%;
  height: 100%;
  background-color: white;
}

.messageMain .header{
  height: 40px;
  width: 100%;
  border-bottom: 1px solid #f5f5f5;
}

.messageMain .header .back{
  width: 20px;
  margin-left: 15px;
  vertical-align: -5px;
}

.messageMain .header span{
  line-height: 40px;
}

.consultTeacherMain .header{
  height: 40px;
  width: 100%;
  border-bottom: 1px solid #f5f5f5;
}

.consultTeacherMain .header span{
  line-height: 40px;
  margin-left: 20px;
}
.mask1{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background-color: rgba(0,0,0,0.50);
	z-index: 999;
}
.mask2{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background-color: rgba(0,0,0,0.50);
	z-index: 99999999;
}
.mask3{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	z-index: 999;
}
.closeBtn{
  width: 20px;
  height: 20px;
  position:absolute;
  right: 10px;
  top: 10px;
}

.consultTeacher .consultTeacherMain .TeacherList{
  width: 100%;
  height: 459px;
  overflow: auto;
  box-sizing: border-box;
  padding: 16px;
}

.consultTeacherMain .TeacherList .teacherCell{
  width: 100%;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}
.consultTeacherMain .TeacherList .teacherCell .goods-num{
  width: 30px;
}
.consultTeacherMain .TeacherList .teacherCell.order{
  padding-bottom: 25px;
  border-bottom: 1px #eee solid;
}
.consultTeacherMain .TeacherList .teacherCell .goods-content{
  margin-left: 10px;
  flex: 1;
}
.consultTeacherMain .TeacherList .teacherCell .goods-content .goods-title{
  font-weight: 700px;
  font-size: 14px;
  line-height: 20px;
  font-size: #101010;
  width: 170px;
  height: 40px;
  font-weight: 700;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal !important;
  word-wrap: break-word; 
}

.consultTeacherMain .TeacherList .teacherCell .goods-price{
  display: flex;
  color: #F34718;
  font-weight: 700;
  align-items: center;
}
.consultTeacherMain .TeacherList .teacherCell .goods-price .stepper{
  margin-left: auto;
  font-weight: 400;
}
.consultTeacherMain .TeacherList .teacherCell .money-symbol{
  font-size: 12px;
}
.consultTeacherMain .TeacherList .teacherCell .money-num{
  font-size: 18px;
}
.consultTeacherMain .TeacherList .teacherCell .to-buy{
  width: 60px;
  height: 25px;
  color: #f5f5f5;
  text-align: center;
  line-height: 25px;
  background: linear-gradient(315deg,#ED3F10,#FB724D);
  border-radius: 4px;
  margin-left: auto;
}
.consultTeacherMain .TeacherList .teacherCell .cover{
  height: 72px;
  width: 110px;
  border-radius: 4px;
}
.consultTeacherMain .TeacherList .form{
  outline: none;
  position: relative;
}
.consultTeacherMain .TeacherList .form input{
  // outline: none;
  width: 200px;
}
.consultTeacherMain .TeacherList i{
  position: absolute;
  font-style: normal;
  left: -8px;
  top: 4px;
}
.consultTeacherMain .footer{
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  width: 100%;
  padding: 0 10px;
  height: 50px;
  box-sizing: border-box;
  align-items: center;
}
.consultTeacherMain .footer .sum-text{
  margin-right: 4px;
}
.consultTeacherMain .footer .sum-money{
  color: #F34718;
  font-weight: 700;
}
.consultTeacherMain .footer .sum-money span:first-child{
  font-size: 14px;
  margin-right: 2px;
}
.consultTeacherMain .footer .sum-money span:last-child{
  font-size: 22px;
}
.consultTeacherMain .footer .comfirm-btn{
  margin-left: auto;
}
.consultTeacherMain .footer .comfirm-btn button{
  border: none;
  color: #FFFFFF;
  width: 100px;
  height: 36px;
  border-radius: 20px;
  background: #0084ff;
}
.qqLogin {
  z-index: 2002 !important;
}
.loginWay {
  padding: 10%;
}
.loginWay .qqtitle {
  color: #000;
  font-size: 16px;
  text-align: center;
}
.loginWay .qqBox {
  display: block;
  font-size: 12px;
  color: #000;
  text-decoration: none;
  margin: 25px 8px 15px 8px;
  text-align: center;
}
.loginWay .qqlogoImg {
  display: block;
  width: 60px;
  height: 60px;
  margin: 0 auto 5px;
}
.tips{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  margin-top: -50%;
}
.tips img{
  width: 200px;
}
.tips span{
  font-size: 20px;
  margin-top: 20px;
}
.mask{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background-color: rgba(0,0,0,0.50);
	z-index: 9999;
}
.qpayb{
  font-weight: 700;
  font-size: 20px;
  margin-top: 8px;
  margin-bottom: 50px;
  text-align: center;
  color: #202020;
}
.payprice{
  font-size: 40px;
}
.paybx{
  padding: 0 28px;
  margin-bottom:30px ;
  display: flex;
  justify-content: space-between;
}
.wxpaybx{
  display: flex;
  /* justify-content: center; */
  align-items: center;
}
.logot{
  width: 24px;
  height: 24px;
}
.checkin{
  width: 20px;
  height: 20px;
}
.qrpaybx{
  display: flex;
  margin-top: 240px;
  margin-bottom: 10px;
  justify-content: center;
}
.qrpay{
  width: 351px;
  line-height: 22px;
  color: #FFFFFF;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  background:#08C160;
  padding:13px 0 ;
}
.tzbxs{
  width: 19px;
  height: 19px;
  position: relative;
  top: -8px;
}
.tzbx{
  padding: 0 10px;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}
.tzbx1{
  padding-top: 40px;
  display: flex;
  justify-content: space-between;
}
.coybx{
  margin-left: 10px;
}
.copy1{
  background: red;
  color: white;
  width: 60px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 40px;
  margin-top: 10px;
  border-radius: 20px;
}
.bzt{
  position: relative;
}
.logot1{
  position: absolute;
  top: -35px;
  left: 7px;
}
</style>